export default __webpack_public_path__ + "static/media/Milly_9781408304808.85088802.jpg";